module.exports = __webpack_public_path__ + "static/img/loopka.eaa2db3a.png";